@if (displayMessages().length >= 1) {
  <div class="app-notification-container">
    @for (messageData of displayMessages(); track $index) {
      @if (this.pageName === "" || messageData.pageName === this.pageName) {
        <mat-card class="notification-card">
          @if (!messageData.ctaData || messageData.ctaData === undefined) {
            <mat-card-content class="notification-card-content">
              <div class="inner-notification-container">
                <div class="message-container">
                  @if (messageData.messageType === "Prenotification") {
                    <i role="img" aria-label="Notification" class="notification-bell fa-light fa-bell fa-2x"></i>
                    <p
                      id="Prenotification"
                      [innerHTML]="messageData.message"
                      [attr.aria-label]="messageData.message"
                      tabindex="0"
                      role="text"
                    ></p>
                  }
                  @if (messageData.messageType === "Alert") {
                    <i
                      role="img"
                      aria-label="Alert"
                      class="fa-solid fa-2x fa-triangle-exclamation"
                      style="color: #eb0000"
                    ></i>
                    <p
                      id="Alert"
                      [innerHTML]="messageData.message"
                      [attr.aria-label]="messageData.message"
                      tabindex="0"
                      role="text"
                    ></p>
                  }
                  @if (messageData.messageType === "Postnotification") {
                    <i role="img" aria-label="Success" class="success-icon fa-sharp fa-light fa-circle-check fa-2x"></i>
                    <p
                      id="Postnotification"
                      [innerHTML]="messageData.message"
                      [attr.aria-label]="messageData.message"
                      class="gs-post-notification"
                      tabindex="0"
                      role="text"
                    ></p>
                  }
                  @if (messageData.messageType === "StatementPreNotification") {
                    <i
                      role="img"
                      aria-label="Information"
                      class="statement-notification fa-light fa-circle-exclamation fa-2x"
                    ></i>
                    <p
                      id="StatementPreNotification"
                      [innerHTML]="messageData.message"
                      [attr.aria-label]="messageData.message"
                      tabindex="0"
                      role="text"
                    ></p>
                  }
                  @if (messageData.messageType === "Error") {
                    <i
                      role="img"
                      aria-label="Error"
                      class="fa-solid fa-2x fa-triangle-exclamation"
                      style="color: #eb0000"
                    ></i>
                    <span
                      id="Error"
                      class="gs-error-notification"
                      tabindex="0"
                      [innerHTML]="messageData.message"
                      [attr.aria-label]="messageData.message"
                      role="text"
                    ></span>
                  }
                  @if (messageData.messageType === "Warning") {
                    <i
                      role="img"
                      aria-label="Warning"
                      class="warning-notification fa-solid fa-circle-exclamation fa-2x"
                    ></i>
                    <p
                      id="Warning"
                      [innerHTML]="messageData.message"
                      [attr.aria-label]="messageData.message"
                      tabindex="0"
                      role="text"
                    ></p>
                  }
                </div>
              </div>
            </mat-card-content>
          } @else {
            <mat-card-content class="notification-card-content-with-cta">
              <div class="message-container">
                @if (messageData.messageType === "Prenotification") {
                  <i role="img" aria-label="Notification" class="notification-bell fa-light fa-bell fa-2x"></i>
                  <p
                    id="Prenotification"
                    [innerHTML]="messageData.message"
                    [attr.aria-label]="messageData.message"
                    tabindex="0"
                    role="text"
                  ></p>
                }
                @if (messageData.messageType === "Alert") {
                  <i
                    role="img"
                    aria-label="Alert"
                    class="fa-solid fa-2x fa-triangle-exclamation"
                    style="color: #eb0000"
                  ></i>
                  <p
                    id="Alert"
                    [innerHTML]="messageData.message"
                    [attr.aria-label]="messageData.message"
                    tabindex="0"
                    role="text"
                  ></p>
                }
                @if (messageData.messageType === "Postnotification") {
                  <i role="img" aria-label="Success" class="success-icon fa-sharp fa-light fa-circle-check fa-2x"></i>
                  <p
                    id="Postnotification"
                    [innerHTML]="messageData.message"
                    [attr.aria-label]="messageData.message"
                    class="gs-post-notification"
                    tabindex="0"
                    role="text"
                  ></p>
                }
                @if (messageData.messageType === "StatementPreNotification") {
                  <i
                    role="img"
                    aria-label="Information"
                    class="statement-notification fa-light fa-circle-exclamation fa-2x"
                  ></i>
                  <p
                    id="StatementPreNotification"
                    [innerHTML]="messageData.message"
                    [attr.aria-label]="messageData.message"
                    tabindex="0"
                    role="text"
                  ></p>
                }
                @if (messageData.messageType === "Error") {
                  <i
                    role="img"
                    aria-label="Error"
                    class="fa-solid fa-2x fa-triangle-exclamation"
                    style="color: #eb0000"
                  ></i>
                  <span
                    id="Error"
                    class="gs-error-notification"
                    tabindex="0"
                    [innerHTML]="messageData.message"
                    [attr.aria-label]="messageData.message"
                    role="text"
                  ></span>
                }
              </div>
              <a
                role="link"
                class="gs-link-btn"
                [attr.aria-label]="messageData.ctaData.ctaAriaLabel"
                [routerLink]="messageData.ctaData.ctaLink"
                [innerHTML]="messageData.ctaData.ctaLabel"
              ></a>
            </mat-card-content>
          }
        </mat-card>
      }
    }
  </div>
}
